import styled, { keyframes } from "styled-components";
export const Form = styled.div`
  border-bottom: 1px solid rgb(224, 224, 227);
  margin: 0px 0px 0px;
  border-radius: 0px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap:10px;
  &.sub {
    box-shadow: none;
    border: 0;
  }
  &.double {
    gap: 10px;
    flex-flow: wrap;
  }
  @media (max-width: 768px) {
    border: 0;
  }
`;
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Overlay = styled.div`
backdrop-filter: blur(5px);
  &.popup {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 25px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.2);
    overflow: auto;
    z-index: 1001;
  }
  &.plain {
    // box-shadow: rgb(0 0 0 / 16%) 0px 5px 9px 0px;
    padding: 20px;
    border-radius: 10px;
    background-color: white;
    margin: auto;
    width: 100%;
    border: 2px solid #d6e0ff;
  }
  &.page{
    overflow: hidden;
    margin: 20px;
  }
  &.contact {
    position: static;
    background-color: #F0F5FF;
    color: #292358;
  }
  &.loginForm {
    padding: 50px 60px;
    @media screen and (max-width: 768px) {
      // padding: 20px;
      // margin: 0 auto;
      width: calc(100% - 40px);
      max-width: 400px;
    }
  }
  @media (max-width: 768px) {
    &.popup {
      width: 100%;
      padding: 0;
      top: 0;
      bottom: 0;
      border-top: 1px solid rgb(224, 224, 227);
    }
    &.plain {
    padding: 20px;
    }
  }
  // position: fixed;
  // top: 0;
  // left: 0;
  // bottom: 0;
  // right: 0;
  // padding: 25px 0;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // background-color: rgba(0, 0, 0, 0.2);
  // overflow: auto;
  // z-index: 1001;
  // backdrop-filter: blur(5px);
  // @media (max-width: 768px) {
  //   width: 100%;
  //   padding: 0;
  //   top: 0;
  //   bottom: 0;
  //   border-top: 1px solid rgb(224, 224, 227);
  // }
`;
export const Page = styled.div`
  display: flex;
  flex-direction: column;
  display: flex;
  background-color: white;
  border-radius: 5px;
  width: 30%;
  min-width: 250px;
  max-width: 100%;
  height: auto;
  animation: ${fadeIn} 1s ease-in-out;
  animation-duration: 0.2s;
  margin: auto;
  // padding: 1em;

  &.double {
    max-width: 650px;
    width: 50%;
  }
  &.tabs {
    max-width: 70%;
    width: 70%;
    margin-top: 10px;
  }
  &.page {
    width: calc(100% - 40px);
    height: 100%;
    margin: 0;
    overflow: auto;
  }
  @media (max-width: 768px) {
    width: 100%;
    position: relative;
    top: 0;
    padding: 10px;
    &.double {
     
      width: 100%;
    }
    &.tabs {
    max-width: 100%;
    width: 100%;
    margin-top: 0px;
  }
  }
`;
export const Header = styled.div`
  text-align: center;
  padding: 0.5em 0 1em;
  font-weight: 500;
  border-radius: 5px;
  font-size: 1.3em;
  @media (max-width: 768px) {
    position: sticky;
    top: 0;
    background: white;
    z-index: 1;
    border-bottom: 1px solid rgb(224, 224, 227);
  }
`;
export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  justify-content: center;
  position: relative;

  @media (max-width: 768px) {
    position: sticky;
    bottom: 0;
    background: white;
    padding-bottom: 10px;
    border-top: 1px solid rgb(224, 224, 227);
  }
`;
export const ErrorMessage = styled.div`
  border-left: 1px solid lightgrey;
  padding-left: 10px;
  margin: 0 0;
  color: #fe7b7b;
  font-size: 12px;
  width: 100%;
  text-align: left;
  float: left;
`;
